import React from 'react';
import styled from 'styled-components';
import PublicNavbar from '../bars/PublicNavbar';
import Footer from '../../../components/Layout/Footer';

// Defining styled components
const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const ContentWrapper = styled.div`
  flex: 1;
`;

const HeaderFixed = styled.header`
  position: fixed;
  top: 20px;
  width: 100%;
  z-index: 1000; /* Ensure the header stays on top of other content */
  background-color: white; /* Use your desired background color */
  padding-left: 20px;
  padding-right: 20px;
`;

const DivAboveHeader = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000; /* Ensure the header stays on top of other content */
  background-color: white; /* Use your desired background color */
  min-height: 20px;
`;

// Modified PublicLayout component using styled-components
class PublicLayout extends React.Component {
  render() {
    const { children } = this.props;
    return (
      <LayoutContainer>
        <DivAboveHeader ></DivAboveHeader>
        <HeaderFixed>
          <PublicNavbar />
        </HeaderFixed>
        <ContentWrapper>
           <div style={{minHeight:'100px'}}></div>
          {children}
        </ContentWrapper>
        <Footer />
      </LayoutContainer>
    );
  }
}

export default PublicLayout;